(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/bigstat/assets/javascripts/bigstat-modal-container.js') >= 0) return;  svs.modules.push('/components/sportinfo/bigstat/assets/javascripts/bigstat-modal-container.js');
'use strict';

const {
  useEffect,
  useCallback
} = React;
const {
  ReactButton,
  ReactIcon
} = svs.ui;
const BigStatModal = svs.components.sportinfo.bigstat.BigStatModal;
const themeClass = svs.components.sportinfo.sportinfo.helpers.themeClass;
const StickyBottom = _ref => {
  let {
    closeModal,
    betslip,
    navigationCallback
  } = _ref;
  return React.createElement("div", {
    className: "sticky-bottom".concat(navigationCallback ? ' with-navigation-arrows' : '').concat(betslip ? ' betslip' : '')
  }, navigationCallback ? React.createElement(React.Fragment, null, React.createElement(ReactButton, {
    className: "sticky-bottom-nav",
    onClick: () => navigationCallback(-1),
    transparent: true
  }, React.createElement(ReactIcon, {
    icon: "menu-left",
    size: "100"
  })), React.createElement(ReactButton, {
    block: true,
    onClick: () => closeModal(),
    transparent: true
  }, "St\xE4ng"), React.createElement(ReactButton, {
    className: "sticky-bottom-nav",
    onClick: () => navigationCallback(1),
    transparent: true
  }, React.createElement(ReactIcon, {
    icon: "menu-right",
    size: "100"
  }))) : React.createElement(ReactButton, {
    block: true,
    inverted: !betslip,
    onClick: () => closeModal(),
    transparent: betslip
  }, "St\xE4ng"));
};
const BigStatModalContainer = _ref2 => {
  let {
    closeNavigationCallback,
    unmountBigStatCallback,
    BigStatProps
  } = _ref2;
  const closeModal = useCallback(() => {
    if (closeNavigationCallback) {
      closeNavigationCallback();
    }
    if (unmountBigStatCallback) {
      unmountBigStatCallback();
    }
  }, [closeNavigationCallback, unmountBigStatCallback]);
  useEffect(() => {
    const safeClose = () => {
      if (unmountBigStatCallback) {
        unmountBigStatCallback();
      }
    };
    window.addEventListener('popstate', safeClose, {
      once: true
    });
    return () => {
      window.removeEventListener('popstate', safeClose);
    };
  }, [closeModal, unmountBigStatCallback]);
  return React.createElement("div", {
    className: BigStatProps === null || BigStatProps === void 0 ? void 0 : BigStatProps.branding
  }, React.createElement(BigStatModal, {
    BigStatProps: BigStatProps,
    Bottom: () => React.createElement(StickyBottom, {
      betslip: BigStatProps.betslip,
      closeModal: closeModal,
      navigationCallback: BigStatProps.navigationCallback
    }),
    className: (BigStatProps === null || BigStatProps === void 0 ? void 0 : BigStatProps.theme) && themeClass(BigStatProps.theme.toLowerCase()),
    isOpen: true
  }));
};
setGlobal('svs.components.sportinfo.bigstat.BigStatModalContainer', BigStatModalContainer);

 })(window);